import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgSales = function SvgSales(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M23.003 3.808a.5.5 0 00-.462-.308h-2.75a.249.249 0 01-.25-.25V.5a.5.5 0 00-.853-.354L16.274 2.56a2.484 2.484 0 00-.733 1.768v1.684a.25.25 0 01-.117.212.495.495 0 00-.09.069l-5 5a1 1 0 101.414 1.414l5-5a.46.46 0 00.07-.09.253.253 0 01.212-.117h1.683c.663.002 1.3-.262 1.768-.733l2.414-2.414a.5.5 0 00.108-.545z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M11.04 8a1 1 0 100-2 6 6 0 106 6 1 1 0 10-2 0 4 4 0 11-4-4z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M21.04 12a1 1 0 10-2 0 8 8 0 11-8-8 1 1 0 100-2 9.991 9.991 0 00-7.16 16.968.25.25 0 01.01.337L1.281 22.35a1 1 0 001.52 1.3l2.661-3.105a.249.249 0 01.321-.05 9.94 9.94 0 0010.514 0 .25.25 0 01.322.05l2.663 3.105a1 1 0 001.518-1.3l-2.608-3.045a.249.249 0 01.01-.336A9.962 9.962 0 0021.04 12z"
  }));
};

export default SvgSales;